import * as React from 'react';
import * as styles from './ModalContent.css';
import { UIText1 } from '@cian/ui-kit';

const TEXT = [
  'Эксперты Федерации ИЖС проверили:',
  'Опыт работы: не менее 3 лет на рынке и построили не менее 10 проектов за предыдущий год.',
  'Репутация компании: были ли задержки строительства и переносы сроков сдачи объектов, отзывы клиентов о построенных объектах, руководстве и сотрудниках компании.',
  'Юридическая чистота компании: наличие необходимой документации, соответствие застройщика требованиям СНиП и ГОСТ.',
  'Финансовая отчётность: бухгалтерские балансы, отчёты о движении денежных средств, уровень капитализации компании, объёмы собственных средств, активы в виде недвижимости и техники.',
];

export const ModalContent = () => {
  return (
    <div className={styles['content']}>
      {TEXT.map((row, index) => (
        <UIText1 key={index}>{row}</UIText1>
      ))}
    </div>
  );
};
